import React from 'react';
import Component from '../../components/Component';
import Datagrid from '../../components/Datagrid';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import DateRange from '../../components/Form/DateRange';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import store from 'store2';

export default class List extends Component {
	constructor(props, context) {
		super(props);

		const rendererLink = (val, row) => {
			return <a href={'/email/'+row.id} onClick={(e) => this.handleOpen(row, e)}>{val}</a>;
		};

		this.columnModel = [{
				name: 'created',
				title: 'Vytvořeno',
				field: 'created',
				width: 120,
				renderer: (val, row) => {
					return rendererLink(Renderers.DateTime(val), row)
				}
			},
			{
				name: 'name',
				title: 'Odesílatel',
				viewport: 'desktop',
				field: 'name'
			},
			{
				name: 'to',
				title: 'Adresát',
				field: 'to'
			},
			{
				name: 'subject',
				title: 'Předmět',
				field: 'subject',
				viewport: 'tablet',
				renderer: rendererLink
			},
			{
				name: 'sent',
				title: 'Odesláno',
				field: 'sent',
				width: 120,
				viewport: 'tablet',
				renderer: Renderers.DateTime
			},
			{
				name: 'edit',
				title: 'Akce',
				field: 'id',
				width:80,
				viewport: 'tablet',
				sortable: false,
				renderer: (val, row) => {
					return (
						<a href={'/email/'+val} onClick={(e) => this.handleOpen(row, e)}>
							<i className="fa fa-pencil position-left"></i>Upravit
						</a>
					);
				}
			}];

		const filterSchema = {
			fulltext: { class: SearchInput },
			created: { class: DateRange },
			name: { class: FilterInput },
			to: { class: FilterInput },
			subject: { class: FilterInput },
			sent: { class: DateRange },
			edit: {
				class: FilterResetButton,
				visible: () => this.filter.isChanged(),
				onClick: () => this.filter.reset()
			}
		};

		this.filter = new FormManager(filterSchema);
        const sessionState = store.session.get('dg-email');
        // default
        let filter = {};
        // session
        if (sessionState && sessionState.filter) {
            filter = sessionState.filter;
        }
        this.defaultFilter = filter;
        this.defaultSort = sessionState && sessionState.sort ? sessionState.sort : {column: 'created', 'direction': 'desc'};
	}

	componentDidMount() {
		this.changeListener = () => {
			this.refs.datagrid.getWrappedInstance().refresh();
		};
		EventEmitter.on('email.change', this.changeListener);
	}

	componentWillUnmount() {
		EventEmitter.removeListener('email.change', this.changeListener);
	}

	handleOpen(row, e) {
		e.preventDefault();
		this.props.actions.openTabForm('email', row.subject, row);
	}

	handleNewClick(e) {
		e.preventDefault();
		this.props.newTab();
	}


	render() {

		const buttons = <Button href="/email/0" onClick={(e) => this.handleNewClick(e)}>
			<i className="fa fa-plus position-left"/>Nový e-mail
		</Button>;


		return (
			<Datagrid
				ref="datagrid"
				id="email"
				api="email.getList"
				buttons={buttons}
				filters={['fulltext']}
				filter={this.filter}
				saveState={true}
				getRowClassName={null}
				columnModel={this.columnModel}
				defaultFilter={this.defaultFilter}
				defaultSort={this.defaultSort}
			/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Email/List.js